import React, { useContext, useMemo, useState } from "react";
import { CardContainer, CardDescription, CardEyebrow, CardImg, CardMeta, CardTextBlock, CardTitle, CardUserName, FavoriteAction, FileFallback, ImgCover, PlayOverlay, ShareContainer } from "./styled";
import DescriptionOutlined from "@mui/icons-material/DescriptionOutlined";
import { Icon, Load } from "ui/styled";
import { isModularContentType, parseStrapiImage } from "utils";
import Toggle from "components/Form/Toggle";
import LockedContentOverlay from "components/LockedContentOverlay";
import { CoreContext } from "context/CoreContext";
import { openLockedContentModal } from "utils/lockedContent";
import AudienceAccessIndicators from "components/AudienceAccessIndicators";
import { getContentAudiences } from "utils/audienceAccess";


export default function VideoCard({ video, wide, favorite, remove, loading, editing, handleDownload, shareLink, selected, onToggleSelect, onToggleFavorite, noShare, supportVideo, fullWidth, titleContent, fallbackLabel }) {
  const [failedPreview, setFailedPreview] = useState(null)
  const { setModal } = useContext(CoreContext)
  const locked = video?.accessState === 'locked'
  const currentFile = useMemo(() => {
    const fileUrl = video?.file?.url ? parseStrapiImage(video?.file?.url) : video?.document;
    const slices = fileUrl?.split(".");
    const extension = slices?.[slices?.length - 1];

    return {
      url: fileUrl,
      extension,
    };
  }, [video]);

  const handleToggle = (e) => {
    e.preventDefault()
    e.stopPropagation()

    if (typeof onToggleSelect === 'function') {
      onToggleSelect({
        targetUid: video?.uid,
        targetDocumentId: video?.documentId,
      })
    }
  }

  const handleFavorite = (e) => {
    e.preventDefault()
    e.stopPropagation()

    if (typeof onToggleFavorite === 'function') {
      onToggleFavorite(video)
    }
  }

  return (
    <CardContainer
      $fullWidth={supportVideo || fullWidth}
      role="button"
      tabIndex={0}
      aria-disabled={locked}
      aria-label={locked ? `${video?.title || 'Content'}. Exclusive content` : `Open ${video?.title || 'content'}`}
      onClick={() => locked ? openLockedContentModal(setModal, video) : handleDownload(video, currentFile)}
      onKeyDown={event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault()
          locked ? openLockedContentModal(setModal, video) : handleDownload(video, currentFile)
        }
      }}
    >
      <CardImg
        $supportVideo={supportVideo}
        ration={video?.type === "article"}
        wide={wide && !isModularContentType(video?.type)}
        course={wide && isModularContentType(video?.type)}
      >

        {video?.type === 'podcasts' ? <Icon icon='play-over' /> : null}
        {!supportVideo ? null : (
          <PlayOverlay aria-hidden="true">
            <Icon icon="play-white" height="28px" width="28px" nomargin />
          </PlayOverlay>
        )}
        {/* {
          loading ? <Load /> : <>
            {(favorite && editing) && <Icon icon="trash" onClick={(e) => { e.stopPropagation(); remove(); return false }} />}
          </>
        } */}
        {!locked && !favorite && typeof onToggleFavorite === 'function' ? (
          <FavoriteAction onClick={handleFavorite}>
            {loading ? <Load /> : <Icon icon={video?.isFavorite ? 'heart-active' : 'heart'} pointer />}
          </FavoriteAction>
        ) : null}
        {video?.type === 'courses' ? null : (
          <AudienceAccessIndicators
            audiences={getContentAudiences(video)}
            belowFavorite={!locked && !favorite && typeof onToggleFavorite === 'function'}
          />
        )}
        {fallbackLabel && ((!video?.cover && !video?.image?.url) || failedPreview === (video?.cover || video?.image?.url)) ? <FileFallback><DescriptionOutlined aria-hidden="true" /><span>{fallbackLabel}</span></FileFallback> : <ImgCover
          src={video?.cover || (video?.image?.url ? parseStrapiImage(video.image.url) : '')}
          alt={video?.title}
          draggable={false}
          onError={fallbackLabel ? () => setFailedPreview(video?.cover || video?.image?.url) : undefined}
        />}
        {locked ? <LockedContentOverlay /> : null}
        {/* <PdfThumbnail url={video?.document} /> */}
      </CardImg>

      {locked || !shareLink || noShare ? null : (
        <ShareContainer onClick={handleToggle}>
          <Toggle label={'Add item'} checked={!!selected} />
        </ShareContainer>
      )}
      <CardTextBlock>
        {video?.category ? <CardEyebrow>{video.category}</CardEyebrow> : null}
        <CardTitle light={favorite}>{titleContent || video?.title}</CardTitle>
        {!supportVideo || !video?.description ? null : <CardDescription>{video.description}</CardDescription>}
        {favorite || (video?.type === "article" ? video?.date : video?.document_type) ? (
          <CardMeta>
            {favorite ? <CardUserName>{video?.type === 'partners-and-staffs' ? 'Partners and Staff' : 'Course'}</CardUserName> : null}
            {favorite && video?.lesson_title ? <CardUserName>{video.lesson_title}</CardUserName> : null}
            {!favorite && (video?.type === "article" ? video?.date : video?.document_type) ? (
              <CardUserName>{video?.type === "article" ? video?.date : video?.document_type}</CardUserName>
            ) : null}
          </CardMeta>
        ) : null}
      </CardTextBlock>
    </CardContainer>
  );
}
